import { render, staticRenderFns } from "./searchDocument.vue?vue&type=template&id=6f40f2fe&scoped=true&"
import script from "./searchDocument.vue?vue&type=script&lang=js&"
export * from "./searchDocument.vue?vue&type=script&lang=js&"
import style0 from "./searchDocument.vue?vue&type=style&index=0&id=6f40f2fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40f2fe",
  null
  
)

export default component.exports